import type { AppointmentServiceLine } from '@erp/appointments/api/appointments.api';

/**
 * Formatea el nombre del servicio para mostrarse en tablas y resumenes.
 * Siempre incluye el ID entre corchetes para facilitar la lectura.
 */
export const formatServiceLineLabel = (line: AppointmentServiceLine): string => {
  const name = line.service_name?.trim();
  const label = name && name.length > 0 ? name : 'Servicio';
  return `[${line.service_id}] ${label}`;
};
